import React from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import {
  resolveAssistantErrorDisplay,
  shouldRenderAssistantErrorCard,
} from './assistantErrorDisplay.js';

const { Text } = Typography;

export function AssistantErrorCard({
  error,
  loading = false,
  onRetry,
  themeTokens,
}) {
  if (!shouldRenderAssistantErrorCard(error) || loading) {
    return null;
  }
  const assistantErrorDisplay = resolveAssistantErrorDisplay(error);
  const recovery = Object.assign({}, error?.recovery);
  const canRetry = recovery.action === 'retry_request' && typeof onRetry === 'function';

  return (
    <div
      className="flare-assistant-meta-row"
      style={{ alignItems: 'flex-start', marginTop: 12 }}
    >
      <Card
        className="flare-error-compact-card"
        size="small"
        styles={{ body: { padding: 10 } }}
        style={{
          borderRadius: 12,
          flex: '0 1 68%',
          maxWidth: '68%',
          width: '100%',
        }}
      >
        <Space orientation="vertical" size={6} style={{ width: '100%' }}>
          <Text strong style={{ color: themeTokens.textPrimary, fontSize: 12 }}>
            {assistantErrorDisplay.title}
          </Text>
          <Text style={{ color: themeTokens.textSecondary, fontSize: 12 }} type="secondary">
            {assistantErrorDisplay.userMessage}
          </Text>
          {canRetry ? (
            <div
              className="flare-message-action-row is-assistant"
              style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'flex-start',
                marginTop: 2,
              }}
            >
              <Button
                aria-label={assistantErrorDisplay.actionLabel}
                icon={<ReloadOutlined />}
                onClick={onRetry}
                size="small"
                type="text"
              >
                {assistantErrorDisplay.actionLabel}
              </Button>
            </div>
          ) : null}
        </Space>
      </Card>
    </div>
  );
}
